import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Layout from "./Layout.jsx";
import Explorer from "./Explorer";

class App extends Component {

  constructor(props) {
    super(props);

    this.onSearchSelection = this.onSearchSelection.bind(this);

    this.state = {
      searchSelection: null
    }
  }

  onSearchSelection(searchResult) {
    this.setState({
      searchSelection: searchResult
    });
  }

  render() {
    return (
      <Router>
        <Layout onSearchSelection={this.onSearchSelection}>
          <Route
            exact
            path="/"
            render={routeProps => <Explorer {...routeProps} {...this.props} searchSelection={this.state.searchSelection} />}
          />
        </Layout>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js